import { useEffect, useState } from 'react';

const defaultTransForm = (currentValue, initialValue) => currentValue;

export function useLocalStorage(key, initialValue, onLoadTransform = defaultTransForm) {
    return useStorage(key, initialValue, window.localStorage, onLoadTransform);
}

export function useSessionStorage(key, initialValue, onLoadTransform = defaultTransForm) {
    return useStorage(key, initialValue, window.sessionStorage);
}

function useStorage(key, initialValue, storage, onLoadTransform = defaultTransForm) {
    const [value, setValue] = useState(() => {
        const item = storage.getItem(key);

        if (item === null) {
            storage.setItem(key, JSON.stringify(initialValue));
            return initialValue;
        }

        try {
            const parsed = JSON.parse(item);
            const transformed = onLoadTransform(parsed, initialValue);

            return transformed;
        } catch {
            return initialValue;
        }
    });

    useEffect(() => {
        if (value === undefined) {
            storage.removeItem(key);
        } else {
            storage.setItem(key, JSON.stringify(value));
        }
    }, [key, value, storage]);

    return [value, setValue];
}
